import { render, staticRenderFns } from "./IconBaseLabel.vue?vue&type=template&id=542caf33"
import script from "./IconBaseLabel.vue?vue&type=script&lang=js"
export * from "./IconBaseLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports